<template>
  <PasswordRestWithTokenForm
    :isPending="passwordResetPending"
    :hasFailed="passwordResetFailed"
    :hasSucceeded="passwordResetSucceeded">
  </PasswordRestWithTokenForm>
</template>

<script>
import { mapState } from 'vuex';

import PasswordRestWithTokenForm from '@/components/auth/PasswordRestWithTokenForm';

export default {
  name: 'PasswordRestWithTokenContainer',
  components: {
    PasswordRestWithTokenForm,
  },
  computed: {
    ...mapState('auth', [
      'passwordResetPending',
      'passwordResetFailed',
      'passwordResetSucceeded',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// PasswordRestWithTokenContainer.vue?2fd6cd43